import { render, staticRenderFns } from "./SceneMaterialImage_adding.vue?vue&type=template&id=7af2da92&scoped=true&"
import script from "./SceneMaterialImage_adding.vue?vue&type=script&lang=js&"
export * from "./SceneMaterialImage_adding.vue?vue&type=script&lang=js&"
import style0 from "./SceneMaterialImage_adding.vue?vue&type=style&index=0&id=7af2da92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af2da92",
  null
  
)

export default component.exports